import { render, staticRenderFns } from "./user_group_management.vue?vue&type=template&id=776b946e&scoped=true"
import script from "./user_group_management.vue?vue&type=script&lang=js"
export * from "./user_group_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b946e",
  null
  
)

export default component.exports